import "../../style/Slide.css";
import "../../style/components/HistorySlide.css";

function HistoryDetails({ steps, activeStep, handleStep, animation, journeyLabel }) {
  const animationClass = animation ? "fade-in" : "fade-out";

  return (
    <div style={{ display: "flex" }}>
      <div className="history-text-button-container">
        <div className="history-content">
          <div className="history-image-container">
            <HistoryImage step={steps[activeStep]} animationClass={animationClass} />
          </div>
          <div className="history-details-text">
            <div className="history-container">
              <div className="cap-r15">{journeyLabel}</div>
              <div className="history-text-container">
                <HistoryText step={steps[activeStep]} animationClass={animationClass} />
              </div>
            </div>
            <div className="history-timeline-wrapper">
              <div className="history-line"></div>
              <div className="history-button-container">
                {steps.map((step, index) => (
                  <HistoryButton
                    key={step.alt}
                    step={step}
                    active={index === activeStep}
                    start={index === 0}
                    onClick={handleStep(index)}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

function HistoryImage({ step, animationClass }) {
  const { alt, image } = step;
  return (
    <img className={`history-image ${animationClass}`} alt={alt} src={image} />
  );
}

function HistoryText({ step, animationClass }) {
  return (
    <div className={`history-text ${animationClass}`}>
      <h1>{step.heading}</h1>
      <div className="body-b1">{step.description}</div>
    </div>
  );
}

function HistoryButton({ step, active, start, onClick }) {
  const startButtonClass = start ? "history-button-start" : "";
  const historyDotClass = active ? "history-dot-active" : "history-dot-default";
  const buttonClass = `custom-button-slide-${active ? "active" : "default"}`;

  return (
    <div className={`history-button ${startButtonClass}`}>
      <div className={`history-dot ${historyDotClass}`}></div>
      <button
        onClick={onClick}
        className={`custom-button-slide ${buttonClass}`}
      >
        {step.date}
      </button>
    </div>
  );
}

export default HistoryDetails;
